import { Button } from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { cmmsTheme } from "@setup/theme/cmms-theme";

// Twin of ExcelButton: same box, same width, same outlined look, shown next to it on the
// Task List.
export const PdfButton = ({ onClick }: { onClick: () => void }) => {
	return (
		<Button
			variant="outlined"
			onClick={onClick}
			style={cmmsTheme.styles.pdfButton}>
			<span
				style={{
					display: "inline-flex",
					alignItems: "center",
					gap: 8,
					lineHeight: 1,
				}}>
				<PictureAsPdfIcon style={{ fontSize: 18, display: "block" }} />
				PDF
			</span>
		</Button>
	);
};
